export const taxonomiesProjection = `
    taxonomies[]-> {
      _id,
      prefLabel,
      slug,
      "label": prefLabel,
      "parent": broader[0]->{
        _id,
        "label": prefLabel,
        slug,
      },
      "grandParent": broader[0]->{
        "_id": broader[0]->{ _id }._id,
        "label": broader[0]->{ "label": prefLabel }.label,
        slug,
      },
    }
`;
export const taxonomiesById = groq`*[_id == $_id][0] {
  ${taxonomiesProjection},
}`;
